import React from 'react';
import Select from 'react-select';
import { customDarkSelectStyles } from './CustomDarkSelectStyles';

const PatchCustomSelect = ({ options, selectedOption, onOptionChange }) => {




  const customOption = ({ innerProps, label, value, isFocused }) => (
    <div
      {...innerProps}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 10px',
        backgroundColor: isFocused ? '#3a3a3a' : '#2c2c2c',
        color: '#f1f1f1',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease-in-out',
      }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#4a4a4a')}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = isFocused ? '#3a3a3a' : '#2c2c2c')}
    >
      <span>{label}</span>
    </div>
  );

  const sortedOptions = [...options].sort((a, b) => {
    const [a1, a2] = a.value.split(".").map(Number);
    const [b1, b2] = b.value.split(".").map(Number);

    return a1 === b1 ? b2 - a2 : b1 - a1;
  });

  return (
    <Select
      hideSelectedOptions={selectedOption.length < 3}
      placeholder={"Patch"}
      isMulti
      options={sortedOptions}
      onChange={onOptionChange}
      value={selectedOption}
      components={{ Option: customOption }}
      styles={customDarkSelectStyles}
    />
  );
};

export default PatchCustomSelect;
